/* eslint-disable */
// source: vivacity/core/anpr_confidence.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.vivacity.core.AnprConfidence', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.AnprConfidence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.core.AnprConfidence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.AnprConfidence.displayName = 'proto.vivacity.core.AnprConfidence';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.AnprConfidence.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.AnprConfidence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.AnprConfidence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AnprConfidence.toObject = function(includeInstance, msg) {
  var f, obj = {
    plate: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hashedPlate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    confidence: jspb.Message.getFieldWithDefault(msg, 3, 0),
    confidenceRank: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.AnprConfidence}
 */
proto.vivacity.core.AnprConfidence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.AnprConfidence;
  return proto.vivacity.core.AnprConfidence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.AnprConfidence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.AnprConfidence}
 */
proto.vivacity.core.AnprConfidence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHashedPlate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConfidence(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConfidenceRank(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.AnprConfidence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.AnprConfidence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.AnprConfidence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.AnprConfidence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHashedPlate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConfidence();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getConfidenceRank();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string plate = 1;
 * @return {string}
 */
proto.vivacity.core.AnprConfidence.prototype.getPlate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AnprConfidence} returns this
 */
proto.vivacity.core.AnprConfidence.prototype.setPlate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string hashed_plate = 2;
 * @return {string}
 */
proto.vivacity.core.AnprConfidence.prototype.getHashedPlate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.AnprConfidence} returns this
 */
proto.vivacity.core.AnprConfidence.prototype.setHashedPlate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 confidence = 3;
 * @return {number}
 */
proto.vivacity.core.AnprConfidence.prototype.getConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.AnprConfidence} returns this
 */
proto.vivacity.core.AnprConfidence.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 confidence_rank = 4;
 * @return {number}
 */
proto.vivacity.core.AnprConfidence.prototype.getConfidenceRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.AnprConfidence} returns this
 */
proto.vivacity.core.AnprConfidence.prototype.setConfidenceRank = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto.vivacity.core);
